// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XrRt","question":"styles_question__2yMfA","description":"styles_description__2fbcZ"};